import {
  type FilterState,
  type FilterType,
  type FilterValuesByType,
} from "../types";

// Get hard typed value from filter state id and type
export function getFilterValue<T extends FilterType>(
  state: FilterState,
  id: string,
  _: T,
): FilterValuesByType[T] {
  return state[id].value as FilterValuesByType[T];
}
